import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            layerStyle: 'page',
            flexDirection: {base: 'column', lg: 'row'},
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            paddingY: {base: 'small-1.base', md: 'medium.md', lg: 'medium.lg', xl: 'medium.xl'},
            textAlign: 'center',
            gap: {base: 'medium.base', md: 'medium.md', lg: 'xxxsmall.lg', xl: 'xxxsmall.xl'},
        },
        contentContainer: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            height: 'stretch',
            width: '100%',
            gap: {base: 'medium.base', md: 'medium.md', lg: 'medium.lg', xl: 'medium.xl'},
            paddingX: {
                base: remCalc(0),
                md: remCalc(0),
                lg: 'medium-3.lg',
                xl: 'medium-3.xl',
            },
            paddingY: remCalc(0),
        },
        sectionsContainer: {
            columns: 2,
            gap: {base: 'medium-1.base', md: 'medium-1.md', lg: 'medium-1.lg', xl: 'medium-1.xl'},
        },
        headerContainer: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            textAlign: 'left',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        title: {
            fontFamily: 'heading',
            textStyle: 'head-xlarge',
            fontWeight: 'light',
            color: 'foreground.neutral.default',
        },
        description: {
            textStyle: 'body-large',
            color: 'foreground.neutral.subtle',
        },
        image: {
            flex: '0 0 auto',
            width: {base: '100%', lg: remCalc(712)},
            height: 'auto',
            aspectRatio: '1 / 1',
            minHeight: {base: remCalc(378), lg: 'unset'},
            maxHeight: {base: 'unset', lg: remCalc(712)},
            objectFit: 'cover',
            borderRadius: {base: 'xl', lg: 'xl-1'},
        },
        sectionItem: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            textAlign: 'left',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        sectionTextContainer: {
            flexDirection: 'column',
            gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
        },
        sectionIcon: {
            width: remCalc(20),
            height: remCalc(20),
        },
        sectionTitle: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        sectionSubtitle: {
            textStyle: 'body-medium',
            fontWeight: 'regular',
            color: 'foreground.neutral.muted',
        },
        sectionButton: {
            textStyle: 'body-small',
            width: 'fit-content',
            height: 'fit-content',
        },
        sectionItemHtml: {
            h2: {
                textStyle: 'body-medium',
                color: 'foreground.neutral.default',
            },
            p: {
                textStyle: 'body-medium',
                color: 'foreground.neutral.muted',
            },
        },
        sectionItemHtmlIcon: {
            width: remCalc(20),
            height: remCalc(20),
            color: 'foreground.neutral.default',
            flexShrink: 0,
        },
    },
    variants: {
        button: {
            sectionsContainer: {
                columns: {base: 1, lg: 2},
            },
            sectionItem: {
                justifyContent: 'space-between',
            },
        },
        productFields: {
            title: {
                textStyle: 'head-large',
                fontWeight: 'light',
            },
            description: {
                textStyle: 'body-xxlarge',
                fontWeight: 'light',
            },
        },
    },
}
